import { observer } from 'mobx-react-lite'
import type { RynoEditorViewModel } from '@/features/legends/ryno/RynoEditorViewModel'
import { RynoEditor } from '@/features/legends/ryno/components/RynoEditor'

export interface RynoEditorContainerProps {
  vm: RynoEditorViewModel
  isDisabled?: boolean
  /**
   * A shorter editor, for tight spots.
   */
  isCompact?: boolean
  'aria-label'?: string
  testId?: string
}

export const RynoEditorContainer = observer(function RynoEditorContainer({
  vm,
  isDisabled,
  isCompact,
  'aria-label': ariaLabel,
  testId,
}: RynoEditorContainerProps) {
  return (
    <RynoEditor
      value={vm.value}
      onChange={vm.setValue}
      diagnostics={vm.sortedDiagnostics}
      completions={vm.autocompleteList}
      isInvalid={vm.hasErrors}
      isDisabled={isDisabled}
      isCompact={isCompact}
      aria-label={ariaLabel}
      testId={testId}
    />
  )
})
